import { useEffect } from "react";
import { useNavigate, useParams } from "@tanstack/react-router";
import { captureShortLink } from "../../lib/attribution";

/** Campaign short links (/go/ig, /ig): record where the visitor came from, then land on the site. */
export function GoPage({ code: fixedCode }: { code?: string }) {
  const params = useParams({ strict: false }) as { code?: string };
  const navigate = useNavigate();
  useEffect(() => {
    const content = new URLSearchParams(window.location.search).get("c") ?? undefined;
    captureShortLink(fixedCode ?? params.code ?? "", content);
    void navigate({ to: "/site", replace: true });
  }, [fixedCode, params.code, navigate]);
  return null;
}
